// @flow
import './style/arcteryx.css';
import withClientPage from '../../hoc/withClientPage';
import withTemplate from '../../hoc/templates/withTemplate';
import withBasic from '../../hoc/templates/withBasic';

const PassedProps = {
  clientBodyClassNames: 'container-fluid arcteryx-main',
  header: 'none',
  headingText: 'arteryx.header',
  headingClassNames: 'arcteryxHeader',
  buttonClassNames: 'arcteryxButton',
  cardInputLabel: 'arcteryx.card.label',
  pinInputLabel: 'arcteryx.pin.label',
  cardInputPlaceholder: 'arcteryx.card.placeholder',
  pinInputPlaceholder: 'arcteryx.pin.placeholder',
  buttonText: 'arcteryx.submit.button',
  resultsHeadingText: 'arcteryx.result.label',
  inputClassNames: 'arcteryxInput',
  labelClassNames: 'arcteryxLabel',
  resultsHeadingClassNames: 'arcteryxResults',
  labelAnimation: false,
  showCardEOV: false,
  justifyContent: 'start',
};

const clientPageProps = {
  title: 'arcteryx.title',
  favicon: '/arcteryx.ico',
  callTranslations: PassedProps.showEnhancedResults,
};

const ARCAG = () => null;

export default withClientPage(withTemplate(withBasic(ARCAG), PassedProps), clientPageProps);
